import type { ColumnDef } from "@tanstack/react-table";
import type { ApVendor } from "@/accounts-payable/types";
import {
  QUICKBOOKS_NOT_LINKED,
  QUICKBOOKS_VENDOR_LABEL,
} from "@/accounts-payable/vendors-tab/quickbooks-labels";

// Shown only while the business has a QuickBooks connection. Unlinked reads
// as quiet text, not a badge: the ServiceTitan link is the exception that
// blocks syncing, and two "Not linked" badges per row would drown it out.
export const quickbooksVendorCol: ColumnDef<ApVendor> = {
  id: "quickbooks_vendor",
  header: QUICKBOOKS_VENDOR_LABEL,
  accessorFn: (row) => row.quickbooks_vendor?.display_name ?? "",
  meta: { size: "240px" },
  cell: ({ row }) =>
    row.original.quickbooks_vendor ? (
      <span className="block truncate">
        {row.original.quickbooks_vendor.display_name}
      </span>
    ) : (
      <span className="text-subtle">{QUICKBOOKS_NOT_LINKED}</span>
    ),
};
